import type { Descendant, Editor } from 'slate';
import { Text } from 'slate';

export const getIOSRedoUndoHandler = (editor: Editor) => (event: InputEvent) => {
  if (event.inputType === 'historyRedo') {
    editor.redo();
  }

  if (event.inputType === 'historyUndo') {
    editor.undo();
  }
};

export const getIsContentChange = (editor: Editor) =>
  editor.operations.some((op) => op.type !== 'set_selection');

export function isNodesEmpty(nodes?: Descendant[]): boolean {
  if (!nodes || nodes.length === 0) return true;
  if (nodes.length > 1) return false;

  const { children } = nodes[0];
  const [first] = children;

  return (
    children.length === 0 || (children.length === 1 && Text.isText(first) && first.text === '')
  );
}
